module.exports = __webpack_public_path__ + "static/media/sf-steuart-3.7869bf47.png";